import React, { useState } from 'react';
import { Button } from '../../../ui/button';
import { Save } from 'lucide-react';

const WorkflowTab = ({ caseId, caseData, timeline, onRefresh, token }) => {
  const [status, setStatus] = useState(caseData?.status || '');
  const [noteText, setNoteText] = useState('');
  const [saving, setSaving] = useState(false);

  const saveStatus = async () => {
    setSaving(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/status`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Status-Update fehlgeschlagen');
      }
      
      onRefresh();
      alert('Status aktualisiert');
    } catch (error) {
      // M11.4: Show document gate error clearly
      alert(error.message || 'Fehler beim Status-Update');
    } finally {
      setSaving(false);
    }
  };

  const addNote = async () => {
    if (!noteText.trim()) return;
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/notes`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: noteText })
      });
      setNoteText('');
      onRefresh();
      alert('Notiz hinzugefügt');
    } catch { alert('Fehler'); }
  };

  return (
    <div className="space-y-8">
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Status ändern</h3>
        <div className="flex gap-4">
          <select value={status} onChange={e => setStatus(e.target.value)} className="flex-1 px-4 py-3 border rounded-xl">
            <option value="eingegangen">Eingegangen</option>
            <option value="in_pruefung">In Prüfung</option>
            <option value="rueckfrage_offen">Rückfrage offen</option>
            <option value="termin_ausstehend">Termin ausstehend</option>
            <option value="termin_geplant">Termin geplant</option>
            <option value="begutachtung_laeuft">Begutachtung läuft</option>
            <option value="gutachten_in_erstellung">Gutachten in Erstellung</option>
            <option value="gutachten_fertig">Gutachten fertig</option>
            <option value="abgeschlossen">Abgeschlossen</option>
          </select>
          <Button onClick={saveStatus} disabled={saving} className="bg-brand-green text-white">
            <Save className="w-4 h-4 mr-2" />Speichern
          </Button>
        </div>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Admin-Notiz</h3>
        <textarea value={noteText} onChange={e => setNoteText(e.target.value)} rows={3} className="w-full px-4 py-3 border rounded-xl mb-3" placeholder="Notiz..." />
        <Button onClick={addNote} disabled={!noteText.trim()} className="bg-gray-900 text-white">Notiz speichern</Button>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Timeline</h3>
        {timeline.length === 0 ? (
          <p className="text-center text-gray-500 py-8">Keine Aktivitäten</p>
        ) : (
          <div className="space-y-4">
            {timeline.map((event, idx) => {
              const typeColors = {
                status_changed: 'bg-blue-50 border-blue-200',
                note_added: 'bg-gray-50 border-gray-200',
                case_submitted: 'bg-green-50 border-green-200',
                request_created: 'bg-orange-50 border-orange-200'
              };
              return (
                <div key={idx} className={`border rounded-xl p-4 ${typeColors[event.type] || 'bg-gray-50 border-gray-200'}`}>
                  <div className="flex justify-between mb-2">
                    <p className="font-semibold text-sm">{event.title}</p>
                    <span className="text-xs opacity-60">{new Date(event.created_at).toLocaleString('de-DE')}</span>
                  </div>
                  {event.message && <p className="text-sm opacity-80">{event.message}</p>}
                  <div className="flex gap-2 text-xs opacity-60 mt-2">
                    <span className="px-2 py-1 bg-black/5 rounded">{event.created_by_role}</span>
                    <span className="px-2 py-1 bg-black/5 rounded">{event.type}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkflowTab;
